export enum MutationMethodEnum {
  post = 'POST',
  put = 'PUT',
  delete = 'DELETE',
}
